import { icon } from "@fortawesome/fontawesome-svg-core";
import React from "react";
import {
  FaEnvelope,
  FaWhatsapp,
  FaLinkedin,
  FaInstagram,
  FaFacebook
} from "react-icons/fa";

function FloatingContact() {
  const items = [
    {
      icon: <FaLinkedin />,
      label: "LinkedIn",
      link: "https://www.linkedin.com/company/wealthgrowfintaxservices/",
    },
    {
      icon: <FaEnvelope />,
      label: "Email",
      link: "mailto:wealthgrowfintaxservices@gmail.com",
    },
    {
      icon: <FaWhatsapp />,
      label: "WhatsApp",
      link: "https://wa.me/919435564566",
    },
    {
      icon: <FaInstagram />,
      label: "Instagram",
      link: "https://www.instagram.com/wealthgrowfintax",
    },
    {
        icon: <FaFacebook />,
        label: "Facebook",
        link: "https://www.facebook.com/share/17yB6CKVe4/",
    }
  ];

  return (
    <div className="fixed left-0 top-1/2 z-50 -translate-y-1/8 md:-translate-y-1/2 md:block">
      <div className="flex flex-col gap-1">

        {items.map((item, index) => (
          <a
            key={index}
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center bg-primary-dark text-accent-gold rounded-r-xl shadow-lg 
            overflow-hidden transition-all duration-300 md:w-10 md:hover:w-40 w-8">
            <div className="flex md:h-12 md:w-12 md:px-2 h-10 w-8 px-1 items-center justify-center text-lg">
              {item.icon}
            </div>

            <span className="whitespace-nowrap opacity-0 group-hover:opacity-100 transition-all duration-300 pr-4 hidden md:block">
              {item.label}
            </span>
          </a>
        ))}

      </div>
    </div>
  );
}

export default FloatingContact;